const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'local';
const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL || '';
const BACKRS_APP_URL = process.env.REACT_APP_BACKRS_URL || '';
const LUBAV_API_URL = process.env.REACT_APP_LUBAV_API_BASEURL || '';
const GROW_URL = process.env.REACT_APP_GROW_URL || '';
const MARKETING_SITE = process.env.REACT_APP_BACKRS_MARKETING_SITE || 'https://www.backrs.com';
const CAL_TEAM_CONSULTATION_URL = process.env.REACT_APP_CAL_TEAM_CONSULTATION_URL || '';
const SANDBOX_CONTACT_FORM_URL =
  process.env.REACT_APP_SANDBOX_CONTACT_FORM_URL ||
  'https://ce704.share.hsforms.com/2UsikrucOStywpq506TbmZw';
const STYTCH_HOST = process.env.REACT_APP_STYTCH_HOST || '';
const STYTCH_PUBLIC_TOKEN = process.env.REACT_APP_STYTCH_PUBLIC_TOKEN || '';
// Connected Apps domain the frontend SDK must use so consent/CIMD resolve against the
// same host as the authorization server. Only applied on live projects.
const STYTCH_CONNECTED_APPS_DOMAIN = process.env.REACT_APP_STYTCH_CONNECTED_APPS_DOMAIN || '';

export {
  ENVIRONMENT,
  ENVIRONMENT_URL,
  LUBAV_API_URL,
  GROW_URL,
  BACKRS_APP_URL,
  MARKETING_SITE,
  CAL_TEAM_CONSULTATION_URL,
  SANDBOX_CONTACT_FORM_URL,
  STYTCH_HOST,
  STYTCH_PUBLIC_TOKEN,
  STYTCH_CONNECTED_APPS_DOMAIN,
};
